import { useState, useEffect, useCallback } from "react";

const ALERT_URL = "micro-alerts/";

export default function AlertsPanel({ theme, token }) {
  const [alerts,  setAlerts]  = useState([]);
  const [total,   setTotal]   = useState(0);
  const [open,    setOpen]    = useState(false);
  const [filter,  setFilter]  = useState("all");
  const [unread,  setUnread]  = useState(0);
  const [lastSeen,setLastSeen]= useState(0);

  const fetchAlerts = useCallback(async () => {
    try {
      const r = await fetch(ALERT_URL, {
        headers: { "X-Auth-Token": token },
        signal: AbortSignal.timeout(8000),
      });
      const d = await r.json();
      setAlerts(d.alerts || []);
      setTotal(d.total || 0);
      const newAlerts = (d.alerts||[]).filter(a => a.id > lastSeen && a.status==="alert").length;
      if (!open) setUnread(v => v + newAlerts);
      if (d.alerts?.length > 0) setLastSeen(d.alerts[0].id);
    } catch {}
  }, [token, open, lastSeen]);

  useEffect(() => {
    fetchAlerts();
    const id = setInterval(fetchAlerts, 30000);
    return () => clearInterval(id);
  }, [fetchAlerts]);

  const filtered = alerts.filter(a =>
    filter === "all" ? true :
    filter === "active" ? a.status === "alert" :
    a.status === "recovered"
  );

  const activeCount = alerts.filter(a => a.status === "alert").length;

  const handleOpen = () => {
    setOpen(v => !v);
    setUnread(0);
  };

  const fmtTime = ts => {
    try {
      const d = new Date(ts);
      return d.toLocaleString("en-IN", { dateStyle:"short", timeStyle:"short" });
    } catch { return ts; }
  };

  return (
    <>
      {/* Alert bell button */}
      <div style={{position:"relative"}}>
        <button onClick={handleOpen} style={{
          background: activeCount > 0 ? "rgba(239,68,68,0.12)" : theme.inputBg,
          border: `1px solid ${activeCount > 0 ? "rgba(239,68,68,0.4)" : theme.border}`,
          color: activeCount > 0 ? "#ef4444" : theme.textMuted,
          borderRadius:6, padding:"5px 12px", cursor:"pointer",
          fontFamily:"'Inter',sans-serif", fontSize:12, fontWeight:600,
          display:"flex", alignItems:"center", gap:6, transition:"all .2s",
        }}>
          {activeCount > 0 ? "🚨" : "🔔"}
          Alerts
          {activeCount > 0 && (
            <span style={{background:"#ef4444",color:"#fff",borderRadius:10,
              padding:"1px 6px",fontSize:10,fontWeight:700}}>{activeCount}</span>
          )}
        </button>
        {unread > 0 && !open && (
          <span style={{position:"absolute",top:-4,right:-4,width:8,height:8,
            borderRadius:"50%",background:"#ef4444",
            boxShadow:"0 0 6px #ef4444"}}/>
        )}
      </div>

      {/* Alerts drawer */}
      {open && (
        <div style={{
          position:"fixed", top:0, right:0, width:440, height:"100vh",
          background:theme.bgCard, borderLeft:`1px solid ${theme.border}`,
          zIndex:1000, display:"flex", flexDirection:"column",
          boxShadow:"-8px 0 32px rgba(0,0,0,0.4)",
        }}>
          {/* header */}
          <div style={{padding:"16px 20px", borderBottom:`1px solid ${theme.border}`,
            display:"flex", justifyContent:"space-between", alignItems:"center",
            background:theme.topbar}}>
            <div>
              <div style={{fontSize:14,fontWeight:700,color:theme.text,
                fontFamily:"'Inter',sans-serif"}}>🚨 Alert Center</div>
              <div style={{fontSize:11,color:theme.textMuted,fontFamily:"'Inter',sans-serif",marginTop:2}}>
                {activeCount} active · {total} total · TN-Micro
              </div>
            </div>
            <button onClick={()=>setOpen(false)} style={{
              background:theme.inputBg, border:`1px solid ${theme.border}`,
              color:theme.textMuted, borderRadius:6, padding:"4px 10px",
              cursor:"pointer", fontSize:11, fontFamily:"'Inter',sans-serif"}}>✕</button>
          </div>

          {/* filter tabs */}
          <div style={{display:"flex",gap:6,padding:"10px 16px",
            borderBottom:`1px solid ${theme.border}`,background:theme.bg}}>
            {[["all","All"],["active","🚨 Active"],["recovered","✅ Recovered"]].map(([k,l])=>(
              <button key={k} onClick={()=>setFilter(k)} style={{
                fontSize:11,padding:"4px 12px",borderRadius:5,cursor:"pointer",
                fontFamily:"'Inter',sans-serif",fontWeight:600,
                background:filter===k?"rgba(239,68,68,0.12)":theme.inputBg,
                border:`1px solid ${filter===k?"rgba(239,68,68,0.35)":theme.border}`,
                color:filter===k?"#ef4444":theme.textMuted,
              }}>{l}</button>
            ))}
            <span style={{marginLeft:"auto",fontSize:10,color:theme.textMuted,
              fontFamily:"'Inter',sans-serif",alignSelf:"center"}}>
              {filtered.length} alerts
            </span>
          </div>

          {/* alert list */}
          <div style={{flex:1,overflowY:"auto",padding:"8px 0"}}>
            {filtered.length === 0 ? (
              <div style={{textAlign:"center",padding:"60px 0",
                fontFamily:"'Inter',sans-serif",fontSize:13,color:theme.textMuted}}>
                {filter==="active" ? "✅ No active alerts!" : "No alerts found"}
              </div>
            ) : filtered.map((a,i) => (
              <div key={i} style={{
                margin:"6px 12px",padding:"12px 14px",borderRadius:8,
                background: a.status==="alert"
                  ? "rgba(239,68,68,0.06)"
                  : "rgba(16,185,129,0.06)",
                border: `1px solid ${a.status==="alert"
                  ? "rgba(239,68,68,0.2)"
                  : "rgba(16,185,129,0.2)"}`,
              }}>
                <div style={{display:"flex",justifyContent:"space-between",
                  alignItems:"flex-start",marginBottom:8}}>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <span style={{fontSize:16}}>
                      {a.status==="alert" ? "🚨" : "✅"}
                    </span>
                    <div>
                      <div style={{fontSize:12,fontWeight:700,color:theme.text,
                        fontFamily:"'Inter',sans-serif"}}>
                        {a.container}
                      </div>
                      <div style={{fontSize:10,color:theme.textMuted,
                        fontFamily:"'Inter',sans-serif"}}>{a.server}</div>
                    </div>
                  </div>
                  <span style={{
                    fontSize:10,fontWeight:700,padding:"2px 8px",borderRadius:4,
                    fontFamily:"'Inter',sans-serif",
                    background: a.status==="alert"?"rgba(239,68,68,0.15)":"rgba(16,185,129,0.15)",
                    color: a.status==="alert"?"#ef4444":"#10b981",
                    border: `1px solid ${a.status==="alert"?"#ef444440":"#10b98140"}`,
                  }}>
                    {a.status==="alert" ? "ALERT" : "RECOVERED"}
                  </span>
                </div>

                {/* metric details */}
                <div style={{display:"flex",gap:8,marginBottom:8}}>
                  <div style={{flex:1,background:theme.metricsBg,borderRadius:6,
                    padding:"6px 10px",border:`1px solid ${theme.border}`}}>
                    <div style={{fontSize:9,color:theme.textMuted,fontFamily:"'Inter',sans-serif",
                      fontWeight:600,letterSpacing:".08em",marginBottom:2}}>METRIC</div>
                    <div style={{fontSize:13,fontWeight:700,color:
                      a.metric==="CPU"?"#06b6d4":"#8b5cf6",
                      fontFamily:"'Inter',monospace"}}>
                      {a.metric==="CPU" ? "⚡" : "💾"} {a.metric}
                    </div>
                  </div>
                  <div style={{flex:1,background:theme.metricsBg,borderRadius:6,
                    padding:"6px 10px",border:`1px solid ${theme.border}`}}>
                    <div style={{fontSize:9,color:theme.textMuted,fontFamily:"'Inter',sans-serif",
                      fontWeight:600,letterSpacing:".08em",marginBottom:2}}>USAGE</div>
                    <div style={{fontSize:13,fontWeight:700,
                      color:a.status==="alert"?"#ef4444":"#10b981",
                      fontFamily:"'Inter',monospace"}}>{a.value}</div>
                  </div>
                  <div style={{flex:1,background:theme.metricsBg,borderRadius:6,
                    padding:"6px 10px",border:`1px solid ${theme.border}`}}>
                    <div style={{fontSize:9,color:theme.textMuted,fontFamily:"'Inter',sans-serif",
                      fontWeight:600,letterSpacing:".08em",marginBottom:2}}>THRESHOLD</div>
                    <div style={{fontSize:13,fontWeight:700,color:theme.textSub,
                      fontFamily:"'Inter',monospace"}}>{a.threshold}</div>
                  </div>
                </div>

                <div style={{fontSize:10,color:theme.textMuted,
                  fontFamily:"'Inter',sans-serif"}}>
                  🕐 {fmtTime(a.timestamp)}
                </div>
              </div>
            ))}
          </div>

          {/* footer */}
          <div style={{padding:"10px 16px",borderTop:`1px solid ${theme.border}`,
            background:theme.topbar,fontSize:10,color:theme.textMuted,
            fontFamily:"'Inter',sans-serif",textAlign:"center"}}>
            Auto-refreshes every 30s · Threshold CPU &gt; 70% · MEM &gt; 70%
          </div>
        </div>
      )}
    </>
  );
}
